import Immutable from 'immutable';

const Content: {
  id?: string,
  name: string | null,
  file: string | null,
  location: string | null,
  protected: boolean,
  type: string | null
} = {
  id: undefined, // TODO FileInfoFont should have an id that is set by the server
  name: null,
  file: null,
  location: null,
  protected: false,
  type: null
};

class FileInfoFont extends Immutable.Record(Content) {
}

export default FileInfoFont;
